module.exports = __webpack_public_path__ + "img/25.b4fd75d.webp";